import { render, staticRenderFns } from "./CardEmployee.vue?vue&type=template&id=520d9edb&scoped=true"
import script from "./CardEmployee.vue?vue&type=script&lang=ts"
export * from "./CardEmployee.vue?vue&type=script&lang=ts"
import style0 from "./CardEmployee.vue?vue&type=style&index=0&id=520d9edb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520d9edb",
  null
  
)

export default component.exports